export var AvatarProfileType;
(function (AvatarProfileType) {
    AvatarProfileType["BUTTON"] = "BUTTON";
    AvatarProfileType["SELECTOR_SIMPLE"] = "SELECTOR_SIMPLE";
    AvatarProfileType["SELECTOR_MULTIPLE"] = "SELECTOR_MULTIPLE";
    /**
     * @deprecated
     * Use NO_TAPPEABLE instead
     */
    AvatarProfileType["NO_TAPEABLE"] = "NO_TAPEABLE";
    AvatarProfileType["NO_TAPPEABLE"] = "NO_TAPPEABLE";
})(AvatarProfileType || (AvatarProfileType = {}));
//# sourceMappingURL=avatarProfileType.js.map